import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from 'redux/store';
import { updateTargetURLCookie } from './utils/storage/updateTargetURLCookie';

import './localization';
import { initialiseGTM } from './utils/TagManager';
import { impersonateAuth } from './utils/storage/impersonateAuth';

import 'assets/styles/main.scss';
import { ReactNode, ComponentType } from 'react';

const isPerformanceAgent = /moto g | Intel Mac OS X 10 | Lighthouse/i.test(navigator.userAgent);

!isPerformanceAgent ? initialiseGTM() : setTimeout(() => initialiseGTM, 5000);

// autologin from admin "impersonate"
impersonateAuth();

const TypedProvider = Provider as ComponentType<{
  store: any;
  children: ReactNode;
}>;

ReactDOM.render(
  <TypedProvider store={store}>
    <App />
  </TypedProvider>,
  document.getElementById('root')
);

updateTargetURLCookie();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
